import { render, staticRenderFns } from "./ot-contract-amendments-display.vue?vue&type=template&id=112c5b5c&scoped=true&"
import script from "./ot-contract-amendments-display.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-amendments-display.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-amendments-display.vue?vue&type=style&index=0&id=112c5b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112c5b5c",
  null
  
)

export default component.exports